"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsElementAtTopOfViewport = exports.useHistoryUrlEffect = exports.useThrottledFunc = exports.useDebouncedFunc = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _underscore = require("underscore");

var useDebouncedFunc = function useDebouncedFunc(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(func, wait);
  }, deps);
};

exports.useDebouncedFunc = useDebouncedFunc;

var useThrottledFunc = function useThrottledFunc(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useMemo)(function () {
    return (0, _underscore.throttle)(func, wait);
  }, deps);
}; // A hook for updating the browser URL, debounced to prevent security warnings from browsers


exports.useThrottledFunc = useThrottledFunc;

var useHistoryUrlEffect = function useHistoryUrlEffect(url) {
  var debounced = useDebouncedFunc(function (newURL) {
    history.replaceState(history.state, '', newURL);
  }, 300);
  (0, _react.useEffect)(function () {
    debounced(url);
  }, [url]);
};

exports.useHistoryUrlEffect = useHistoryUrlEffect;

var useIsElementAtTopOfViewport = function useIsElementAtTopOfViewport() {
  var viewportStartY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var elementRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAtTopOfViewport = _useState2[0],
      setIsAtTopOfViewport = _useState2[1];

  (0, _react.useEffect)(function () {
    var onScroll = (0, _underscore.throttle)(function () {
      var _elementRef$current$g = elementRef.current.getBoundingClientRect(),
          top = _elementRef$current$g.top,
          height = _elementRef$current$g.height;

      setIsAtTopOfViewport(top <= viewportStartY + 200 && top >= viewportStartY - height);
    }, 300);
    window.addEventListener('scroll', onScroll);
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, []);
  return [elementRef, isAtTopOfViewport];
};

exports.useIsElementAtTopOfViewport = useIsElementAtTopOfViewport;